import BreadcrumbListSD from 'components/common/SEO/BreadcrumbListSD'
import FacebookOGMetas from 'components/common/SEO/FacebookOGMetas'
import OrganisationSD from 'components/common/SEO/OrganisationSD'
import TwitterMarups from 'components/common/SEO/TwitterMarups'
import WebPageSD from 'components/common/SEO/WebPageSD'
import WebSiteSD from 'components/common/SEO/WebSiteSD'
import { TopicPath } from 'navigation/Routes'
import { Helmet } from 'react-helmet'
import Text from './text.json'

const breadcrumbList = (slug, title) => [
  {
    link: window.location.origin,
    name: 'Accueil'
  },
  {
    link: `${window.location.origin}${TopicPath}`,
    name: "parcours d'apprentissage"
  },
  {
    link: `${window.location.origin}${TopicPath}/${slug}`,
    name: title
  }
]

export default ({ name, introduction, metaTitle, metaDescription, slug }) => {
  const description = `${name} ${introduction}`
  const link = `${window.location.origin}${TopicPath}/${(slug ?? name)}`
  const selectedTitle = metaTitle || `${Text.prefixTitle} ${name} ${Text.sufixTitle}`
  const selectedDescription = metaDescription || description
  return (
    <>
      <Helmet>
        <title>{selectedTitle}</title>
        <meta name='description' content={selectedDescription} />
        <link rel='canonical' href={link} />
      </Helmet>
      <FacebookOGMetas
        link={link}
        title={selectedTitle}
        description={description}
      />
      <TwitterMarups
        link={link}
        title={selectedTitle}
        description={description}
      />
      <OrganisationSD />
      <WebSiteSD />
      <WebPageSD
        title={selectedTitle}
        description={description}
      />
      <BreadcrumbListSD items={breadcrumbList(name, name)} />
    </>
  )
}
